/**
 * Extension fields for the Planner client
 */ export class PlannerClientExtensions {
    constructor(gridSettings){
        this.gridSettings = gridSettings;
    }
}
